__turbopack_context__.v({
  "divider": "ProjectsPage-module-scss-module__Xmz7oG__divider",
  "orbDrift": "ProjectsPage-module-scss-module__Xmz7oG__orbDrift",
  "page": "ProjectsPage-module-scss-module__Xmz7oG__page",
  "pageDescription": "ProjectsPage-module-scss-module__Xmz7oG__pageDescription",
  "pageHeader": "ProjectsPage-module-scss-module__Xmz7oG__pageHeader",
  "pageShell": "ProjectsPage-module-scss-module__Xmz7oG__pageShell",
  "projectsList": "ProjectsPage-module-scss-module__Xmz7oG__projectsList",
});
